import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import {
  closeAddressModal as dispatchCloseAddressModal,
  showAddressModal as dispatchShowAddressModal,
} from '@/_store/modules/layout';
import type { ShowAddressModalData } from '@/_store/modules/layout/types';

const useAddressModal = () => {
  const dispatch = useAppDispatch();

  const openedAddressModal = useAppSelector(
    state => state.layout.openedAddressModal,
  );

  function showAddressModal(data: ShowAddressModalData) {
    dispatch(dispatchShowAddressModal(data));
  }

  function closeAddressModal() {
    if (openedAddressModal) {
      dispatch(dispatchCloseAddressModal());
    }
  }

  return {
    openedAddressModal,
    showAddressModal,
    closeAddressModal,
  };
};

export default useAddressModal;
